/**
 * Data structure for approval-related information
 */
export interface ApprovalData {
    comment?: string,
}

/**
 * Request payload for processing approval actions
 */
export interface ProcessApprovalRequest {
    entityId: string,
    approvalData: ApprovalData
}

/**
 * Response returned after processing an approval request
 */
export interface ProcessApprovalResponse {
    entityId: string
}

/**
 * Types of entities that can be processed for approval
 */
export enum ApprovalType {
    MULTI_ALLOCATION_SHEET = "MULTI_ALLOCATION_SHEET",
    MULTI_ALLOCATION_WORKSHEET = "MULTI_ALLOCATION_WORKSHEET"
}

/**
 * Available approval actions that can be performed on entities
 */
export enum ApprovalAction {
    APPROVE = "APPROVE",
    REJECT = "REJECT",
    SUBMIT = "SUBMIT"
}